module.exports = __webpack_public_path__ + "static/media/carta_36.75244811.jpg";